export const getLanguageForKey = (object, key, lang) => {
  if (object[`${key}_${lang}`]) return object[`${key}_${lang}`];
  return object[`${key}`];
};
